import React, { useState, useEffect } from 'react';
import { Heart, ExternalLink } from 'lucide-react';
import { mockDonations, subscribeToDB } from '../services/mockDatabase';

const Charity = () => {
  const [stats, setStats] = useState({ totalDonated: 0, goalAmount: 1000, donationPercentage: 0.10 });

  useEffect(() => {
    setStats(mockDonations.getDonationStats());
    const unsubscribe = subscribeToDB(() => {
      setStats(mockDonations.getDonationStats());
    });
    return unsubscribe;
  }, []);

  const progress = Math.min(100, Math.round((stats.totalDonated / stats.goalAmount) * 100));

  return (
    <section id="mission" className="py-16 px-6 max-w-4xl mx-auto">
      <div className="bg-white rounded-3xl p-8 shadow-xl border-4 border-pink-100 text-center">
        <div className="flex justify-center mb-4 text-red-500 animate-pulse">
          <Heart size={48} fill="currentColor" />
        </div>
        <h2 className="text-3xl font-bold text-gray-800 mb-2">Helping St. Jude Children's Research Hospital</h2>
        <p className="text-gray-600 mb-6 italic text-lg max-w-2xl mx-auto">
          "A portion of every sale goes directly to St. Jude to help kids get better! Currently, we donate {(stats.donationPercentage * 100).toFixed(0)}% of all shop proceeds."
        </p>
        
        {/* Donation Stats Tally */}
        <div className="flex justify-around mb-6 text-sm md:text-base font-semibold text-gray-700 bg-pink-50/50 p-4 rounded-2xl">
          <div>
            <span className="block text-xs uppercase text-gray-400 font-bold mb-1">Total Donated</span>
            <span className="text-pink-600 text-xl font-bold">${stats.totalDonated.toFixed(2)}</span>
          </div>
          <div className="border-r border-gray-200"></div>
          <div>
            <span className="block text-xs uppercase text-gray-400 font-bold mb-1">Current Goal</span>
            <span className="text-gray-800 text-xl font-bold">${stats.goalAmount.toFixed(2)}</span>
          </div>
          <div className="border-r border-gray-200"></div>
          <div>
            <span className="block text-xs uppercase text-gray-400 font-bold mb-1">Our Progress</span>
            <span className="text-purple-600 text-xl font-bold">{progress}%</span>
          </div>
        </div>

        {/* Donation Progress Bar */}
        <div className="w-full bg-gray-100 rounded-full h-8 relative overflow-hidden mb-8 border border-gray-200 shadow-inner">
          <div 
            className="bg-gradient-to-r from-red-400 via-pink-500 to-purple-600 h-full rounded-full transition-all duration-1000"
            style={{ width: `${progress}%` }}
          >
            <span className="absolute inset-0 flex items-center justify-center text-white font-bold text-sm drop-shadow-md">
              Goal Progress: {progress}%
            </span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="https://www.stjude.org/donate/donate-to-st-jude.html"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-red-500 to-pink-600 text-white font-bold px-6 py-3 rounded-full hover:shadow-lg transition-transform hover:-translate-y-0.5 text-sm"
          >
            Donate Directly to St. Jude <ExternalLink size={14} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Charity;
